export enum BookmarkType {
    NORMAL = "normal",
    IMAGE = "image"
  }

export const bookmarkLinkEditInfo = {
  editExcludeFields: []
}